<template>
    <b-form-group>
        <label class="mb-1 text-lg d-flex align-items-center">
            Email
        </label>
        <b-input v-model="entry.email" type="text" placeholder="Nhập email..." />
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    data: () => ({
        entry: {
            email: "",
        },
    }),
    watch: {
        "entry.email": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    email: this.entry.email,
                });
            },
            deep: true,
        },
        "value.email": {
            handler: function () {
                this.entry.email = this.value.email;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
};
</script>